// extracted by mini-css-extract-plugin
export default {"custom-dropdown":"InfoOrder_custom-dropdown__oosYP","item":"InfoOrder_item__1zj75"};